
import { useResourceViewer } from "../../../../components/customHook/ResourceViewer";
import MediaViewerModal from "../../../../components/modal/MediaViewerModal";
import { useInfoUser } from "../../../../store/UserStore";
import { PanelView } from "../PanelView";

const GroupInfoPanel = ({ jumpToMessage, openModal }) => {
  const { languageMap } = useInfoUser();

  const resourceViewer = useResourceViewer();
  return (
    <div className="w-[350px] h-screen bg-white border-l flex flex-col">
      {/* Header */}
      <div className="relative p-3 border-b flex justify-center items-center h-[70px]">
        <span className="absolute left-1/2 -translate-x-1/2 font-semibold text-[18px]">
          {languageMap?.["menu.conversation.groupInfo"] ?? "Group information"}
        </span>
      </div>
      {/* Content */}
      <div className="flex flex-col h-screen overflow-y-scroll w-[350px]">
        <PanelView
          jumpToMessage={jumpToMessage}
          openModal={openModal}
          resourceViewer={resourceViewer}
        />
      </div>
      {/* Modal viewer */}
      {resourceViewer?.visible && (
        <MediaViewerModal resourceViewer={resourceViewer} />
      )}
    </div>
  );
};

export { GroupInfoPanel };
